import { t as g } from "./theme-DtbpEDJK.js";
import * as i from "react";
const o = {
  primary: {
    base: "",
    fill: "bg-gradient-to-r from-brand-horizon-blue to-brand-ultra-soft-violet text-brand-primary-50 bg-origin-border",
    outline: "border-brand-dusk text-brand-dusk"
  },
  secondary: {
    base: "",
    fill: "bg-brand-star text-brand-space-blue",
    outline: "border-brand-star text-brand-star"
  },
  danger: {
    base: "",
    fill: "bg-error text-white",
    outline: "border-error text-error"
  },
  warning: {
    base: "",
    fill: "bg-warning text-brand-space-blue",
    outline: "border-warning text-warning"
  }
};
function d({
  children: r,
  variant: n = "primary",
  outline: a,
  className: t,
  as: l = "button",
  ...b
}) {
  const e = [
    // basic styles
    "rounded-lg font-button uppercase whitespace-nowrap font-medium py-1 px-2 text-sm border-2",
    // focus styles
    "outline-none outline-offset-0 focus-visible:outline-nebula",
    // disabled styles
    "disabled:bg-neutral-light disabled:text-brand-space-blue disabled:bg-none disabled:brightness-100 disabled:opacity-80"
  ], s = o[n] || o.primary;
  return e.push(s.base), a ? (e.push("bg-transparent hover:brightness-125 active:brightness-150"), e.push(s.outline)) : (e.push("border-transparent hover:brightness-90 active:brightness-75"), e.push(s.fill)), t && e.push(t), /* @__PURE__ */ i.createElement(l, { ...b, className: e.join(" ") }, r);
}
function u({
  className: r,
  children: n,
  ...a
}) {
  const t = [
    // class to use in css
    "mission.io-select-wrapper",
    // basic tailwind classes
    "rounded-lg border-2 border-neutral py-1 px-2 cursor-pointer bg-white bg-gradient-to-t to-[33%] from-cloud-blue to-white",
    // disabled styles
    "has-[select:disabled]:cursor-not-allowed has-[select:disabled]:bg-gradient-to-t has-[select:disabled]:from-neutral has-[select:disabled]:to-neutral-light",
    // remove some of these for transparency
    "focus-within:ring-2 focus-within:ring-nebula"
    // 'focus-within:border-dusk',
  ];
  return a.multiple || t.push(
    "after:content-[''] after:justify-self-end after:w-[0.8rem] after:h-2 after:bg-neutral after:[clip-path:polygon(100%_0%,_0_0%,_50%_100%)] after:[grid-area:select]"
  ), r && t.push(r), /* @__PURE__ */ i.createElement("div", { className: t.join(" ") }, /* @__PURE__ */ i.createElement(
    "select",
    {
      ...a,
      className: "[grid-area:select] appearance-none bg-transparent border-none p-0 pr-4 m-0 w-full z-10 outline-none leading-tight"
    },
    n
  ));
}
export {
  d as Button,
  u as Select,
  g as theme
};
